import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { ROUTES } from '@/shared/constants/routes';
import { useTeleprompterEnabled } from './useTeleprompterEnabled';

/** Flag desligada (ou reuniao sem a capacidade) = a rota nao existe: volta para a reuniao, sem paywall. */
export function TeleprompterRouteGuard({ children }: { children: ReactNode }) {
  const { meetingId = '' } = useParams();
  const { enabled, loading } = useTeleprompterEnabled();
  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }
  if (!enabled) {
    return <Navigate to={meetingId ? ROUTES.MEET_MEETING(meetingId) : ROUTES.MEET} replace />;
  }
  return <>{children}</>;
}
